import { Banner, BannerDescription, Link } from '@aloft/toolkit-sui';

import { Link as ReactRouterLink } from 'react-router-dom';

import { useToolkitControllerGlobal } from '../controller/hooks/useToolkitControllerGlobal.ts';
import { featuresSelectors } from '../redux/features/selectors/featuresSelectors.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { getTrialEndMessage } from '../utils/getTrialEndMessage.ts';

const { selectShouldAllowTrialWithoutPayment } = featuresSelectors;

export const TrialEndingBanner = () => {
  const { subscription } = useToolkitControllerGlobal();
  const allowTrialWithoutPayment = useAppSelector((state) =>
    selectShouldAllowTrialWithoutPayment(state, subscription),
  );

  if (!allowTrialWithoutPayment) return null;
  if (!subscription.hasActiveSubscription || subscription.type !== 'trialing') return null;

  const title = getTrialEndMessage(subscription);

  return (
    <Banner
      status="info"
      title={title}
      description={
        <BannerDescription>
          Enjoying Toolkit?&nbsp;
          <Link href="/subscribe" as={ReactRouterLink}>
            Upgrade now
          </Link>
          &nbsp;to continue enjoying market-based adjustments!
        </BannerDescription>
      }
      canDismiss={false}
    />
  );
};
